import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { resetInitialHistoryLoaded } from '../state/slices/integrationSlice';
import { fetchDeviceTypeMap, fetchSystemTypeMap } from '../state/thunks';

export default function useIntegrationInit({ enabled = true } = {}) {
  const dispatch = useDispatch();
  const startedRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      startedRef.current = false;
      // Reset initial history loaded flag when user logs out
      dispatch(resetInitialHistoryLoaded());
    }
  }, [enabled, dispatch]);

  useEffect(() => {
    if (!enabled || startedRef.current) return;
    startedRef.current = true;

    const init = async () => {
      // Load integration baselines once after auth.
      await Promise.all([dispatch(fetchDeviceTypeMap()), dispatch(fetchSystemTypeMap())]);
    };

    init();
  }, [dispatch, enabled]);
}
